import startCase from 'lodash/startCase';
import { batch } from 'react-redux';
import {
  setAvailability,
  setHasDeadZone,
  checkForZoneCountMismatch
} from 'advanced';
import {
  setOriginalScenarioUuid,
  setActiveScenarioUuid,
  setYourPlanScenarioUuid,
  parseAndStoreScenario
} from 'advanced/scenarios';
import { storeScript } from 'scripts';
import { getMessage } from 'util/locale';
import { parseSeasonCode } from 'seasons/util';
import { addMessage } from 'messages';
import { messageTypes } from 'constants/values';

export const processAdvancedScriptAvailability = ({ dispatch, availability }) => {
  dispatch(setAvailability(availability));
  return Promise.resolve(availability);
};

const generateBadLayerText = ({ badCciLayers, badYieldLayers }) => {
  const yieldMessages = badYieldLayers.map( layer => parseSeasonCode(layer.layerSpec))
  .map( ({ year, crop }) => `${year} ${getMessage('text__yield')} ${getMessage(crop) || startCase(crop)}`) // i18n hack to get around not-yet-translated crops
  .join(', '); // <- not localized / i18n

  const cciMessages = badCciLayers.map( layer => {
    const year = (new Date( layer.layerSpec)).getFullYear();
    return `${year} ${getMessage('label-text__layer-type--cci')}`;
  }).join(', ');

  const messages = [yieldMessages, cciMessages].filter( truthy => truthy ).join(', '); // More not-localized / i18n
  return messages;
};

export const processAdvancedScriptTemplate = ({
  dispatch,
  template,
  sliderTemplate,
  badCciLayers=[],
  badYieldLayers=[],
  hasDeadZone=false,
  newCurrentAveragePopulation
}) => {
  badYieldLayers = badYieldLayers || [];
  badCciLayers = badCciLayers || [];

  // TODO - I've flagged all of this to have the text be more i18n friendly
  if(badCciLayers.length || badYieldLayers.length) {
    const messages = generateBadLayerText({ badCciLayers, badYieldLayers });
    const text = `
    ${getMessage('text__success--generate-prescription')}
    ${getMessage('text__inform--unused-layers')}
    ${messages}
    `;
    dispatch(addMessage({messageType: messageTypes.SUCCESS, text, toast: false }));
  }
  // TODO: Find a way to cache below so finder doesn't have to re-fetch/parse/process

  // Only store the original script when the user lands on step 3, not on every movement of 
  // the slider.
  batch(() => {
    if (!newCurrentAveragePopulation) {
      dispatch(checkForZoneCountMismatch(template));
      dispatch(setHasDeadZone(hasDeadZone));
      dispatch(storeScript(template));
      dispatch(parseAndStoreScenario(template));
      dispatch(setActiveScenarioUuid(template.id));
      dispatch(setOriginalScenarioUuid(template.id));
    }
    // A slider template is the script that matches the position of the slider. If there is one
    // we need to create it and set it as actual
    // If there is a newCurrentAveragePopulation there was a movement on the slider.
    // not a user landing on step 3.
    if (sliderTemplate) {
      dispatch(storeScript(sliderTemplate));
      dispatch(parseAndStoreScenario(sliderTemplate));
      dispatch(setActiveScenarioUuid(sliderTemplate.id));
      if (!newCurrentAveragePopulation) {
        dispatch(setYourPlanScenarioUuid(sliderTemplate.id));
      }
    }
  });
  return {
    parsedScript: template,
    parsedSliderScript: sliderTemplate
  };
};
